export default "__VITE_ASSET__BEzYjvg___"